/* global axios */
import ApiClient from '../ApiClient';

class CaptainMcpServers extends ApiClient {
  constructor() {
    super('captain/mcp_servers', { accountScoped: true });
  }

  get({ page = 1 } = {}) {
    return axios.get(this.url, { params: { page } });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data = {}) {
    return axios.post(this.url, { mcp_server: data });
  }

  update(id, data = {}) {
    return axios.put(`${this.url}/${id}`, { mcp_server: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Synchronous discovery — server returns the refreshed record so the
  // store can replace it without a follow-up GET.
  refresh(id) {
    return axios.post(`${this.url}/${id}/refresh`);
  }
}

export default new CaptainMcpServers();
